import React, { useState, useRef } from "react";
import { Box, Typography, Stack, Button } from "@mui/material";
import ImageIcon from "@mui/icons-material/Image";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import DriveFileRenameOutline from "@mui/icons-material/DriveFileRenameOutline";

export default function ImageTile({
  label, name, src, onPick, onRemove,
  ratio = "1 / 1", hint = "Upload image", objectFit = "cover",
  disabled = false, size = "sm" // sm = compact, md = a bit taller
}) {
  const [err, setErr] = useState(false);
  const ref = useRef(null);
  const pick = () => !disabled && ref.current?.click();

  const tilePadding = size === "sm" ? 0 : 0; // keep super compact
  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: .5, color: "text.secondary" }}>{label}</Typography>
      <Box
        onClick={pick}
        sx={{
          position: "relative", borderRadius: 1, overflow: "hidden",
          aspectRatio: ratio, cursor: disabled ? "default" : "pointer",
          border: (t) => `1px solid ${t.palette.divider}`, p: tilePadding,
          "&:hover .act": { opacity: disabled ? 0 : 1, transform: "translateY(0)" }
        }}
      >
        {!src || err ? (
          <Box sx={{
            height: "100%", display: "flex", alignItems: "center", justifyContent: "center",
            border: (t) => `1px dashed ${t.palette.divider}`, bgcolor: (t)=>t.palette.action.hover
          }}>
            <Stack spacing={.5} alignItems="center" sx={{ color: "text.secondary" }}>
              <ImageIcon fontSize="small" />
              <Typography variant="caption">{hint}</Typography>
            </Stack>
          </Box>
        ) : (
          <img src={src} alt={label} onError={()=>setErr(true)} style={{ width:"100%", height:"100%", objectFit }} />
        )}

        <Stack direction="row" spacing={1} className="act" sx={{
          position: "absolute", bottom: 8, right: 8, opacity: 0, transform: "translateY(6px)",
          transition: "all .16s ease"
        }}>
          <Button size="small" variant="contained" startIcon={<DriveFileRenameOutline/>}
                  onClick={(e)=>{e.stopPropagation(); pick();}} disabled={disabled}>Change</Button>
          <Button size="small" variant="outlined" color="error" startIcon={<DeleteOutline/>}
                  onClick={(e)=>{e.stopPropagation(); onRemove?.();}} disabled={disabled}>Remove</Button>
        </Stack>

        <input ref={ref} type="file" accept="image/*" hidden onChange={(e)=>{
          const f = e.target.files?.[0]; if (!f) return; setErr(false); onPick?.(name, f); e.target.value = "";
        }}/>
      </Box>
    </Box>
  );
}
